<template>
  <vx-card title="Penalizaciones">
    <vs-table :data="project.penalties.items">

      <div slot="header" class="mb-2">
        <penalize-button
          class="float-right"
          :project="project"></penalize-button>
      </div>

      <template slot="thead">
        <vs-th>ID</vs-th>
        <vs-th>TXR</vs-th>
        <vs-th>%</vs-th>
        <vs-th>Monto</vs-th>
        <vs-th>Concepto</vs-th>
        <vs-th>Referencia</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Creado</vs-th>
        <vs-th width="180px">Acciones</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="payment in data" v-bind:key="payment.id">
          <td>{{ payment.id }}</td>
          <td>{{ payment.trxType }}</td>
          <td>{{ percentage(payment.amount) }}</td>
          <td>{{ payment.amount|currency }}</td>
          <td>
            <a :href="$sanitizeUrl(`/admin/suppliers/${payment.profileId}`)">
              {{ payment.concept }}
            </a>
          </td>
          <td>{{ payment.reference }}</td>
          <td>{{ payment.status }}</td>
          <td>{{ payment.createdAt|_humanizeDate }}</td>
          <td></td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import PenalizeButton from "@components/penalize/penalize-button";
import {_humanizeDate} from "@/filters/momentTzConvert";
import {LoanProject} from "@/models/LoanPayment/Project";
export default {
  name: "supplier-penalties",
  components: {PenalizeButton},
  props: {
    project: {
      type: LoanProject,
      required: true
    }
  },
  filters: {
    _humanizeDate
  },
  methods: {
    percentage(val) {
      return ((val / this.project.totalCost) * 100).toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>
